export const mockMenuLinks = [
  {
    href: '/imei-check',
    titleKey: 'headerLink1',
    links: [
      {
        href: '/imei-blacklist-check',
        titleKey: 'headerLink1SubItem1',
      },
      {
        href: '/imei-sim-lock-check',
        titleKey: 'headerLink1SubItem2',
      },
      {
        href: '/meid-number-check',
        titleKey: 'headerLink1SubItem3',
      },
      {
        href: '/samsung-imei-check',
        titleKey: 'headerLink1SubItem4',
      },
      {
        href: '/imei-check/samsung-tablet',
        titleKey: 'headerLink1SubItem5',
      },
      {
        href: '/imei-check/samsung-galaxy-watch',
        titleKey: 'headerLink1SubItem6',
      },
      {
        href: '/imei-check/google-pixel',
        titleKey: 'headerLink1SubItem7',
      },
      {
        href: '/imei-check/xiaomi',
        titleKey: 'headerLink1SubItem8',
      },
      {
        href: '/imei-check/motorola',
        titleKey: 'headerLink1SubItem9',
      },
      {
        href: '/imei-check/oneplus',
        titleKey: 'headerLink1SubItem10',
      },
      {
        href: '/imei-check/vivo',
        titleKey: 'headerLink1SubItem11',
      },
      {
        href: '/imei-check/oppo',
        titleKey: 'headerLink1SubItem12',
      },
      {
        href: '/imei-check/realme',
        titleKey: 'headerLink1SubItem13',
      },
      {
        href: '/imei-check/huawei',
        titleKey: 'headerLink1SubItem14',
      },
      {
        href: '/imei-check/lg',
        titleKey: 'headerLink1SubItem15',
      },
      {
        href: '/imei-check/lenovo',
        titleKey: 'headerLink1SubItem16',
      },
      {
        href: '/imei-check/lenovo-tablet',
        titleKey: 'headerLink1SubItem17',
      },
      {
        href: '/imei-check/lenovo-laptop',
        titleKey: 'headerLink1SubItem18',
      },
      {
        href: '/imei-check/asus',
        titleKey: 'headerLink1SubItem19',
      },
      {
        href: '/imei-check/sony',
        titleKey: 'headerLink1SubItem20',
      },
      {
        href: '/imei-check/nokia',
        titleKey: 'headerLink1SubItem21',
      },
      {
        href: '/imei-check/htc',
        titleKey: 'headerLink1SubItem22',
      },
      {
        href: '/imei-check/honor',
        titleKey: 'headerLink1SubItem23',
      },
      {
        href: '/imei-check/zte',
        titleKey: 'headerLink1SubItem24',
      },
      {
        href: '/imei-check/alcatel',
        titleKey: 'headerLink1SubItem25',
      },
    ],
  },
  {
    href: '/serial-number-check',
    titleKey: 'headerLink2',
    links: [
      { href: '/samsung-serial-number-check', titleKey: 'headerLink2SubItem1' },
      {
        href: '/serial-number-check/samsung-notebook',
        titleKey: 'headerLink2SubItem2',
      },
      {
        href: '/serial-number-check/samsung-galaxy-buds',
        titleKey: 'headerLink2SubItem3',
      },
      {
        href: '/serial-number-check/samsung-laptop',
        titleKey: 'headerLink2SubItem4',
      },
      {
        href: '/serial-number-check/samsung-galaxy-watch',
        titleKey: 'headerLink2SubItem5',
      },
      {
        href: '/serial-number-check/samsung-earbuds',
        titleKey: 'headerLink2SubItem6',
      },
      { href: '/serial-number-check/xiaomi', titleKey: 'headerLink2SubItem7' },
      {
        href: '/serial-number-check/motorola',
        titleKey: 'headerLink2SubItem8',
      },
      { href: '/serial-number-check/oneplus', titleKey: 'headerLink2SubItem9' },
      { href: '/serial-number-check/vivo', titleKey: 'headerLink2SubItem10' },
      { href: '/serial-number-check/oppo', titleKey: 'headerLink2SubItem11' },
      { href: '/serial-number-check/realme', titleKey: 'headerLink2SubItem12' },
      { href: '/serial-number-check/huawei', titleKey: 'headerLink2SubItem13' },
      {
        href: '/serial-number-check/huawei-watch',
        titleKey: 'headerLink2SubItem14',
      },
      {
        href: '/serial-number-check/huawei-laptop',
        titleKey: 'headerLink2SubItem15',
      },
      { href: '/serial-number-check/asus', titleKey: 'headerLink2SubItem16' },
      {
        href: '/serial-number-check/blackberry',
        titleKey: 'headerLink2SubItem17',
      },
      {
        href: '/serial-number-check/google-pixel',
        titleKey: 'headerLink2SubItem18',
      },
      { href: '/serial-number-check/htc', titleKey: 'headerLink2SubItem19' },
      { href: '/serial-number-check/lenovo', titleKey: 'headerLink2SubItem20' },
      { href: '/serial-number-check/lg', titleKey: 'headerLink2SubItem21' },
      {
        href: '/serial-number-check/microsoft',
        titleKey: 'headerLink2SubItem22',
      },
      { href: '/serial-number-check/nokia', titleKey: 'headerLink2SubItem23' },
      { href: '/serial-number-check/sony', titleKey: 'headerLink2SubItem24' },
      { href: '/serial-number-check/zte', titleKey: 'headerLink2SubItem25' },
    ],
  },
  {
    href: '/check-imei-apple',
    titleKey: 'headerLink3',
    links: [
      {
        href: '/iphone-imei-check',
        titleKey: 'headerLink3SubItem1',
      },
      {
        href: '/check-imei-apple/ipad',
        titleKey: 'headerLink3SubItem2',
      },
      {
        href: '/check-imei-apple/mac',
        titleKey: 'headerLink3SubItem3',
      },
      {
        href: '/check-imei-apple/watch',
        titleKey: 'headerLink3SubItem4',
      },
      {
        href: '/check-imei-apple/airpods',
        titleKey: 'headerLink3SubItem5',
      },
    ],
  },
  {
    href: '/apple-serial-number-check',
    titleKey: 'headerLink4',
    links: [
      {
        href: '/iphone-serial-number-check',
        titleKey: 'headerLink4SubItem1',
      },
      {
        href: '/apple-serial-number-check/macbook',
        titleKey: 'headerLink4SubItem2',
      },
      {
        href: '/apple-serial-number-check/ipad',
        titleKey: 'headerLink4SubItem3',
      },
      {
        href: '/apple-serial-number-check/airpods',
        titleKey: 'headerLink4SubItem4',
      },
      {
        href: '/apple-serial-number-check/ipod',
        titleKey: 'headerLink4SubItem5',
      },
      {
        href: '/apple-serial-number-check/watch',
        titleKey: 'headerLink4SubItem6',
      },
      {
        href: '/apple-serial-number-check/mouse',
        titleKey: 'headerLink4SubItem7',
      },
    ],
  },
  {
    href: '/blog',
    titleKey: 'headerLink6',
    asLink: true,
  },
  // {
  //   href: null,
  //   titleKey: 'headerLink5',
  //   links: [
  //     {
  //       href: '/att-check-imei',
  //       titleKey: 'headerLink5SubItem1',
  //     },
  //     {
  //       href: '/verizon-check-imei',
  //       titleKey: 'headerLink5SubItem2',
  //     },
  //     {
  //       href: '/tmobile-check-imei',
  //       titleKey: 'headerLink5SubItem3',
  //     },
  //     {
  //       href: '/kddi-check-imei',
  //       titleKey: 'headerLink5SubItem4',
  //     },
  //   ],
  // },
];
